import { render, staticRenderFns } from "./EditMembers.vue?vue&type=template&id=1321540d&lang=pug"
import script from "./EditMembers.vue?vue&type=script&lang=js"
export * from "./EditMembers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports